import { Router } from '@angular/router';
import { SessionsServiceConfig, SessionsServiceConfigProvider } from '../lib/services/sessions.service';
import { Injectable } from '@angular/core';
import { CustomAuthProvider as CustomTokenProvider } from '../lib/services/auth-providers/custom.provider';
import { SessionSignInFlag } from '../lib/components/session-signin/session-signin.component';
import { Amplify } from 'aws-amplify';
import { confirmResetPassword, resetPassword } from 'aws-amplify/auth';
import { environment } from '../../../../environment/environment';

@Injectable()
export class DefaultSessionsServiceConfigProvider implements SessionsServiceConfigProvider {
  public constructor(private router: Router) {}

  public getConfig(): SessionsServiceConfig {
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: environment.cognito.userPoolId,
          userPoolClientId: environment.cognito.userPoolWebClientId,
          loginWith: { email: true, username: true },
        },
      },
    });

    return {
      autoRefreshCredentials: true,
      persistSessions: true,
      onSelectionRequired: () => {
        // Do nothing, don't navigate to session/select
      },
      onSignInRequired: (session) => {
        const currentUrl = this.router.url;
        if (currentUrl !== '/app/fleet-management') {
          this.router.navigate(['session', 'signin'], {
            queryParams: { prefill_session: session.id, flags: SessionSignInFlag.SignInRequired },
          });
        }
      },
      onSessionActivated: () => this.router.navigate(['']),
      sessionDiscriminator: (session) => session.id,
      authProviders: [
        new CustomTokenProvider('custom_token', {
          label: 'Cognito',
          icon: 'pi pi-key',
          resetPassword: async (username: string) => {
            await resetPassword({ username });
          },
          confirmResetPassword: async (username: string, confirmationCode: string, newPassword: string) => {
            await confirmResetPassword({ username, confirmationCode, newPassword });
          },
          authenticate: async (_credentials) => {
            throw new Error('Use CognitoService to sign in');
          },
          fields: [
            {
              key: 'email',
              type: 'email',
              icon: 'pi pi-at',
              label: 'Email',
              saveForPrefill: true,
            },
          ],
          getSessionIdentifier: (token, claims) => claims.id,
        }),
      ],
    } as SessionsServiceConfig;
  }
}
